export default <T>(thing: T | undefined | false | null): thing is T =>
  thing !== undefined && thing !== false && thing !== null
